import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

// Import images
import ClientsHeroImg from '../assets/img/Clients-hero.png';
import TestUser3 from '../assets/img/test-user-2.png';
import SwasigraLogo from '../assets/img/swas_logo.png';
import CoolSpringLogo from '../assets/img/coolspring_logo.png';
import VenbaBricksLogo from '../assets/img/venba-logo.png';
import VimiMagicLogo from '../assets/img/vimimagic-logo.png';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';

const Clients = () => {
  const testimonialsData = [
    {
      img: TestUser3,
      quote: "From the initial project planning to the final implementation, your team's professionalism and technical proficiency have been outstanding. You've not only met but exceeded our expectations in every aspect of this project.",
      name: "Arun Paul",
      role: "MalayaWood"
    },
    {
      img: SwasigraLogo,
      quote: "We are extremely pleased with the quality of service and solutions provided. Your team's expertise and dedication have significantly contributed to our business growth and operational efficiency.",
      name: "Swasigra",
      role: "Client"
    },
    {
      img: CoolSpringLogo,
      quote: "The innovative solutions and exceptional support from your team have transformed our business operations. Your commitment to excellence and customer satisfaction is truly commendable.",
      name: "Cool Spring",
      role: "Client"
    },
    {
      img: VenbaBricksLogo,
      quote: "Working with your team has been a remarkable experience. Your technical expertise, attention to detail, and timely delivery have exceeded our expectations and helped us achieve our business goals.",
      name: "Venba Bricks",
      role: "Client"
    },
    {
      img: VimiMagicLogo,
      quote: "Your team's professionalism and innovative approach to problem-solving have been instrumental in our success. We highly appreciate the quality of work and ongoing support provided.",
      name: "Vimi Magic",
      role: "Client"
    }
  ];

  const designProcess = [
    {
      icon: "fa-solid fa-handshake-angle",
      title: "Empathize",
      description: "Understand users' needs through observation and interaction."
    },
    {
      icon: "fa-solid fa-lightbulb",
      title: "Ideate",
      description: "Generate creative ideas to solve user problems."
    },
    {
      icon: "fa-solid fa-cube",
      title: "Prototype",
      description: "Create models to test and refine concepts."
    },
    {
      icon: "fa-solid fa-vial",
      title: "Testing",
      description: "Gather feedback to improve the design."
    }
  ];

  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">
            Clients
          </h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">Clients</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Client Hero Section Start */}
      <section className="pt-50">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6">
              <div className="pr50 pr0-xl mb30-md position-relative">
                <h1 className="animate-up-1 mb15 text-thm2">
                  Why <span className="text-thm">Choose Us</span>
                </h1>
                <div className="advance-search-tab at-home6 bgc-white bdrs4 p10 position-relative zi2 animate-up-3">
                  <div className="row">
                    <div className="col-md-9 col-lg-8 col-xl-9">
                      <div className="content">
                        <p className="font-size-p">
                          We create the best and the most seamlessly integrated ecosystem for your business that works like a well-oiled machine - Technology, Managed Services, Application Development, Database Management, Enterprise Solutions and everything!
                        </p>
                        <p className="font-size-p">
                          Our continued and dedicated focus on satisfying customer needs and our commitment to remain resolute on the ethics of workmanship, make us one of the best development companies in Coimbatore.
                        </p>
                        <p className="font-size-p">
                          As a workplace we strive to provide an inclusive, accomodating environment where creativity and excellence thrive.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-5">
              <div className="home6-hero-content position-relative">
                <img 
                  src={ClientsHeroImg} 
                  alt="client-hero-img" 
                  className="animate-up-1 w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Client Hero Section End */}

      {/* Design Process Section Start */}
      <section className="bg-white p-50">
        <div className="container wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="main-title text-center mb-20">
                <h2>Our Design Process</h2>
                <p className="font-size-p text">Most products we are using these process</p>
              </div>
            </div>
          </div>
          <div className="row">
            {designProcess.map((process, index) => (
              <div className="col-sm-6 col-lg-3" key={index}>
                <div className="iconbox-style1 at-home17-v1 after_style p-0 text-center">
                  <div className="icon before-none">
                    <i className={process.icon}></i>
                  </div>
                  <div className="details">
                    <h4 className="title mt10 mb-3">{process.title}</h4>
                    <p className="font-size-p text">{process.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Design Process Section End */}

      {/* Testimonials Section Start */}
      <section id="testimonials" className="testimonials">
        <div className="container" data-aos="fade-up">
          <header className="section-header">
            <h2>Testimonials</h2>
            <p className="font-size-p text-center section-heading text-blue">
              What they are saying about us
            </p>
          </header>
          <div className="testimonial mySwiper">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }}
              pagination={{
                clickable: true,
                el: '.swiper-pagination'
              }}
            >
              {testimonialsData.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="slide swiper-slide">
                    <img 
                      src={testimonial.img} 
                      alt={`testimonials-${index + 1}`} 
                      className="image" 
                    />
                    <p className="font-size-p">{testimonial.quote}</p>
                    <i className="bx bxs-quote-alt-left quote-icon"></i>
                    <div className="details">
                      <span className="name">{testimonial.name}</span>
                      <span className="job">{testimonial.role}</span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="swiper-button-next nav-btn"></div>
            <div className="swiper-button-prev nav-btn"></div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>
      {/* Testimonials Section End */}
      <Footer/>
    </div>
  );
};

export default Clients;